//@ts-check
import languages from '../languages';
/**
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {import('./types').EcrionFormLayout}
 */

var calculate = function calculate(state) {
  var formField = state.fields[state.formId]; // return empty layout if form structure is not recognized

  if (formField.type !== 'form') return {
    pages: [],
    containers: {},
    paginationType: 'none'
  };
  var translatedField = languages.translate(state, formField);
  var fieldMeta = state.meta && state.meta[formField.id];
  var layout = {
    pages: [],
    containers: {},
    paginationType: getPaginationType(formField, state),
    variant: getFormVariant(formField),
    submitButtonContent: fieldMeta && fieldMeta['submitTmpl'] || translatedField.submitTmpl || formField.submitTmpl || '',
    backButtonContent: translatedField.backButtonTmpl || formField.backButtonTmpl || '',
    continueButtonContent: translatedField.continueButtonTmpl || formField.continueButtonTmpl || ''
  };
  readPagesLayouts(formField, state, layout);
  return layout;
};
/**
 * @param {import('../logic/types').EcrionFormContainer} container
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 */


var readPagesLayouts = function readPagesLayouts(container, state, layout) {
  if (!container || !container.children) return [];
  if (!isVisibleField(container, state)) return [];
  container.children.forEach(function (childId) {
    var field = state.fields[childId];
    if (!field) return;
    if (field.type === 'page') readPageLayout(field, state, layout);
    if (field.type === 'subform') readPagesLayouts(field, state, layout);
  });
};
/**
 * @param {import('../logic/types').EcrionFormPageField} page
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 */


var readPageLayout = function readPageLayout(page, state, layout) {
  if (!page || !page.children) return;
  if (!isVisibleField(page, state)) return; // add the page in the pages list

  layout.pages.push(page.id);
  readContainerRows(page, state, layout);
};
/**
 * @param {Array<import('../logic/types').EcrionFormField>} fields
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 * @returns {Array<import('./types').EcrionFormRowLayout>}
 */


var calculateFieldsLayout = function calculateFieldsLayout(fields, state, layout) {
  var rows = [];
  /**@type {import('./types').EcrionFormRowLayout} */

  var row = {
    fields: []
  };
  var availableColumns = 12;

  if (fields) {
    fields.forEach(function (field) {
      if (field.type === 'break') return availableColumns = 0;
      var fieldLayout = readFieldLayout(field, state, layout);

      if (fieldLayout.size <= availableColumns) {
        row.fields.push(fieldLayout); // substract current field size from available size

        availableColumns -= fieldLayout.size;
      } else {
        row.id = generateRowId(row.fields.map(function (field) {
          return field.id;
        }));
        rows.push(row); // add this new row to the current page
        // create a new row and add new field to the list

        row = {
          fields: [fieldLayout]
        }; // substract current field size from max size

        availableColumns = 12 - fieldLayout.size;
      }
    });
  } // add last row the page


  if (row.fields.length) {
    row.id = generateRowId(row.fields.map(function (field) {
      return field.id;
    }));
    rows.push(row);
  }

  return rows;
};
/**
 * @param {import('../logic/types').EcrionFormContainer} container
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 */


var readContainerRows = function readContainerRows(container, state, layout) {
  var fields = getVisibleFields(container, state);
  var rows = calculateFieldsLayout(fields, state, layout);
  layout.containers[container.id] = {
    rows: rows
  };
};
/**
 * @param {import('../logic/types').EcrionFormRepeatingField} repeating
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 */


var readRepeatingRows = function readRepeatingRows(repeating, state, layout) {
  if (!repeating.childrenMap) return; // each value from a repeating row will generate a group container

  repeating.childrenMap.forEach(function (item) {
    var suffix = "_".concat(item.value);
    var children = item.children;
    var fields = children.map(function (id) {
      return state.fields[id];
    });
    fields = fields.filter(function (field) {
      return isVisibleField(field, state);
    });
    var rows = calculateFieldsLayout(fields, state, layout);
    layout.containers["".concat(repeating.id).concat(suffix)] = {
      rows: rows
    };
  });
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormState} state
 * @param {import('./types').EcrionFormLayout} layout
 * @returns {import('./types').EcrionFormFieldLayout}
 */


var readFieldLayout = function readFieldLayout(field, state, layout) {
  var size = getFieldSize(field);
  if (field.type === 'datagroup') readContainerRows(field, state, layout);
  if (field.type === 'repeating') readRepeatingRows(field, state, layout);
  return {
    id: field.id,
    size: size
  };
};
/**
 * Get the number of column a field wants to ocupy in a 12 column layout
 * Must be a number between 1 and 12
 * @param {import('../logic/types').EcrionFormField} field
 * @returns {import('./types').ColumnSize}
 */


var getFieldSize = function getFieldSize(field) {
  if (field.shrink === '1') return 6;
  if (field.shrink === '2') return 4;
  if (field.shrink === '3') return 3;
  return 12; // by default we have an entire row
};
/**
 * Search for visible fields of a container.
 * @param {import('../logic/types').EcrionFormContainer} container
 * @param {import('../logic/types').EcrionFormState} state
 * @param {string} suffix // Use this to add suffix to all id's of the container fields (usefull for repeating container fields)
 * @returns {Array<import('../logic/types').EcrionFormField>}
 */


var getVisibleFields = function getVisibleFields(container, state) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!container.children) return [];
  var fields = container.children.map(function (id) {
    return state.fields[id + suffix];
  });
  return fields.filter(function (field) {
    return isVisibleField(field, state);
  });
};
/**
 * @param {import('../logic/types').EcrionFormField} field
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {boolean}
 */


var isVisibleField = function isVisibleField(field, state) {
  if (!field) return false;
  if (field.type === 'script') return false;
  if (field.type === 'xmlfield') return false;
  if (!state.meta[field.id]) return !state.meta[field.originalId] || !state.meta[field.originalId].hidden;
  return !state.meta[field.id].hidden;
};
/**
 * @param {Array<string>} fields
 * @returns string
 */


var generateRowId = function generateRowId(fields) {
  return fields.reduce(function (prev, next, idx) {
    return idx === 0 ? prev : prev + next;
  });
};
/**
 * @param {import('../logic/types').EcrionFormRootField} root
 * @param {import('../logic/types').EcrionFormState} state
 * @return {'tabs' | 'pager' | 'none'}
 */


var getPaginationType = function getPaginationType(root, state) {
  var paginationType = root.paginationType;
  if (paginationType === 'none') return 'none';
  if (paginationType === 'simpletabs') return 'pager';
  var pages = Object.keys(state.fields).filter(function (fieldId) {
    return state.fields[fieldId].type === 'page';
  });
  return pages.length === 1 ? 'none' : 'tabs';
};
/**
 * @param {import('../logic/types').EcrionFormRootField} root
 * @return {'outlined' | 'standard'}
 */


var getFormVariant = function getFormVariant(root) {
  if (!root.variant || root.variant === 'outlined') return 'outlined';
  return 'standard';
};

export default calculate;